














































































































































































import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import MedicineSearchDialog from "./MedicineSearchDialog.vue";
import MedicineProductSearchDialog from "./MedicineProductSearchDialog.vue";
import MedicineDetailDialog from "./MedicineDetailDialog.vue";
import MedicineRegisterDialog, {
  RegisterPayload
} from "./MedicineRegisterDialog.vue";
import MedicineProductDetailDialog, {
  MedicineItemView
} from "./MedicineProductDetailDialog.vue";
import { renderMedicineHtml } from "./medicineTextConverter";
import QRCodeScannerDialog from "@/components/patient/medicine/QRCodeScannerDialog.vue";
import QRCodeConfirmDialog from "@/components/patient/medicine/QRCodeConfirmDialog.vue";
import { ScannedMedicine } from "@/components/patient/medicine/types";

interface MedicineItem {
  id: number;
  yj_code: string;
  medicine_name: string;
  photo_file_name: string;
  sub_photo_file_names: string[];
  products: ProductView[];
  exact_matched?: boolean;
}

/** MedicineDetailDialog / MedicineSearchDialog 向けの商品詳細型 */
interface ProductView {
  product_name: string;
  major_heading: string;
  unit: string;
  generic_name: string;
  category: string;
  indications: string;
  dosage: string;
  features: string;
}

interface PatientMedicine {
  id: number;
  patient_id: number;
  yj_code: string;
  start_date: string;
  end_date: string;
  remarks: string;
  updated_at: string;
  medicine: MedicineItem | null;
}

/** MedicineDetailDialog 向けの表示用型 */
interface MedicineView {
  yj_code: string;
  name: string;
  is_generic: boolean;
  unit: string;
  generic_name: string;
  category: string;
  indications: string;
  dosage: string;
  features: string;
  photo_file_name: string;
  sub_photo_file_names: string[];
  products: ProductView[];
}

@Component({
  components: {
    MedicineSearchDialog,
    MedicineProductSearchDialog,
    MedicineDetailDialog,
    MedicineRegisterDialog,
    MedicineProductDetailDialog,
    QRCodeScannerDialog,
    QRCodeConfirmDialog
  }
})
export default class MedicationHistory extends Mixins(AxiosMixin) {
  /** 利用者ID */
  private patientId = 0;

  /** 利用者お薬一覧 */
  private patientMedicines: PatientMedicine[] = [];

  /** 詳細ダイアログ用 */
  private selectedMedicineView: MedicineView | null = null;
  private isDetailDialogOpen = false;
  private isDetailViewOnly = true;

  /** 登録・編集ダイアログ用 */
  private isRegisterDialogOpen = false;
  private registerYjCode = "";
  private registerMedicineName = "";
  private registerPhotoFileName = "";
  private registerExistingData: {
    id: number;
    start_date: string;
    end_date: string;
    remarks: string;
    updated_at: string;
  } | null = null;

  private isSearchDialogOpen = false;
  private isProductSearchDialogOpen = false;

  /** 商品詳細ダイアログ用（一覧のREFリンクから開く） */
  private isProductDetailOpen = false;
  private refProductId = "";

  private headers = [
    {
      text: "画像",
      value: "type",
      align: "center",
      sortable: false,
      width: "72px"
    },
    { text: "薬剤名", value: "medicine_name", sortable: false },
    { text: "規格単位", value: "unit", sortable: false },
    { text: "開始日", value: "start_date", sortable: false, width: "110px" },
    { text: "終了日", value: "end_date", sortable: false, width: "110px" },
    { text: "備考", value: "remarks", sortable: false },
    {
      text: "アクション",
      value: "actions",
      align: "center",
      sortable: false,
      width: "220px"
    }
  ];

  /** QRコードスキャナーダイアログ表示フラグ */
  private showScanner = false;

  /** QRコード確認ダイアログ表示フラグ */
  private showConfirm = false;

  /** QRコードから読み取ったお薬データ */
  private scannedItems: ScannedMedicine[] = [];

  created() {
    this.patientId = Number(this.$route.params.id);
    this.fetchPatientMedicines();
  }

  /** 規格単位取得 */
  private renderHtml(text: string): string {
    return renderMedicineHtml(text);
  }

  private getMedicineUnit(item: PatientMedicine): string {
    if (
      !item.medicine ||
      !item.medicine.products ||
      item.medicine.products.length === 0
    ) {
      return "";
    }
    return item.medicine.products[0].unit;
  }

  /** PatientMedicine を詳細ダイアログ用 MedicineView に変換 */
  private toMedicineView(pm: PatientMedicine): MedicineView {
    const medicine = pm.medicine;
    if (!medicine) {
      return {
        yj_code: pm.yj_code,
        name: "",
        is_generic: false,
        unit: "",
        generic_name: "",
        category: "",
        indications: "",
        dosage: "",
        features: "",
        photo_file_name: "",
        sub_photo_file_names: [],
        products: []
      };
    }
    const products: ProductView[] = medicine.products || [];
    const firstProduct = products.length > 0 ? products[0] : null;
    const isGeneric = products.some(p => p.category.includes("後発"));
    return {
      yj_code: medicine.yj_code,
      name: medicine.medicine_name,
      is_generic: isGeneric,
      unit: firstProduct ? firstProduct.unit : "",
      generic_name: firstProduct ? firstProduct.generic_name : "",
      category: firstProduct ? firstProduct.category : "",
      indications: firstProduct ? firstProduct.indications : "",
      dosage: firstProduct ? firstProduct.dosage : "",
      features: firstProduct ? firstProduct.features : "",
      photo_file_name: medicine.photo_file_name || "",
      sub_photo_file_names: medicine.sub_photo_file_names || [],
      products
    };
  }

  /** 利用者お薬一覧取得 */
  private fetchPatientMedicines(): void {
    this.postJsonCheck(
      window.base_url + "/api/patient/medicines/get",
      { patient_id: this.patientId },
      res => {
        this.patientMedicines = res.data.patient_medicines || [];
      }
    );
  }

  private closeVisitPage() {
    window.close();
  }

  /** 一覧内のREFリンクをクリックしたとき商品詳細ダイアログを開く */
  private onTableClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === "A" && target.classList.contains("medicine-ref")) {
      event.preventDefault();
      const productId = target.getAttribute("data-product-id");
      if (productId) {
        this.refProductId = productId;
        this.isProductDetailOpen = true;
      }
    }
  }

  /** 商品詳細からお薬を選択 → 商品詳細を閉じてお薬詳細ダイアログを開く */
  private onSelectMedicineFromProduct(medicine: MedicineItemView) {
    this.selectedMedicineView = medicine as MedicineView;
    this.isDetailViewOnly = false;
    this.isProductDetailOpen = false;
    this.isDetailDialogOpen = true;
  }

  /** 薬剤詳細・商品名検索のREFリンク → 薬剤詳細を閉じて商品詳細を開く */
  private onOpenProductDetail(productId: string) {
    this.isDetailDialogOpen = false;
    this.refProductId = productId;
    this.isProductDetailOpen = true;
  }

  private openSearchDialog() {
    this.isSearchDialogOpen = true;
  }

  private openProductSearchDialog() {
    this.isProductSearchDialogOpen = true;
  }

  /** 検索ダイアログでお薬を選択 → 詳細ダイアログ（登録ボタンあり） */
  private onSelectMedicine(medicine: MedicineView) {
    this.selectedMedicineView = medicine;
    this.isDetailViewOnly = false;
    this.isDetailDialogOpen = true;
  }

  /** 詳細ダイアログの「登録する」→ 登録ダイアログへ */
  private onRegisterFromDetail(medicine: MedicineView) {
    this.registerYjCode = medicine.yj_code;
    this.registerMedicineName = medicine.name;
    this.registerPhotoFileName = medicine.photo_file_name;
    this.registerExistingData = null;
    this.isRegisterDialogOpen = true;
  }

  /** 詳細ボタン → 薬学情報閲覧（登録ボタンなし） */
  private openDetail(pm: PatientMedicine) {
    this.selectedMedicineView = this.toMedicineView(pm);
    this.isDetailViewOnly = true;
    this.isDetailDialogOpen = true;
  }

  /** 編集ボタン → 開始日・終了日・備考の編集 */
  private openEdit(pm: PatientMedicine) {
    this.registerYjCode = pm.yj_code;
    this.registerMedicineName = pm.medicine
      ? pm.medicine.medicine_name
      : pm.yj_code;
    this.registerPhotoFileName = pm.medicine
      ? pm.medicine.photo_file_name || ""
      : "";
    this.registerExistingData = {
      id: pm.id,
      start_date: pm.start_date,
      end_date: pm.end_date,
      remarks: pm.remarks,
      updated_at: pm.updated_at
    };
    this.isRegisterDialogOpen = true;
  }

  /** 登録・更新 */
  private onSaveMedicine(payload: RegisterPayload) {
    this.postJsonCheck(
      window.base_url + "/api/patient/medicine/save",
      {
        patient_medicine: {
          id: payload.id,
          patient_id: this.patientId,
          yj_code: payload.yj_code,
          start_date: payload.start_date,
          end_date: payload.end_date,
          remarks: payload.remarks,
          updated_at: payload.updated_at
        }
      },
      () => {
        this.fetchPatientMedicines();
      }
    );
    this.isSearchDialogOpen = false;
    this.isProductSearchDialogOpen = false;
    this.isDetailDialogOpen = false;
    this.isProductDetailOpen = false;
  }

  /** 削除 */
  private async deleteMedicine(pm: PatientMedicine) {
    if (!(await this.$openConfirm("このお薬を削除しますか？"))) return;
    this.postJsonCheck(
      window.base_url + "/api/patient/medicine/delete",
      {
        patient_medicine: {
          id: pm.id,
          patient_id: pm.patient_id,
          updated_at: pm.updated_at
        }
      },
      () => {
        this.fetchPatientMedicines();
      }
    );
  }

  /** QRコードスキャナーを開く */
  private openQRScanner() {
    this.showScanner = true;
  }

  /** QRコード読み取り完了 */
  private onScanned(items: ScannedMedicine[]) {
    this.scannedItems = items;
    this.showConfirm = true;
  }

  /**
   * QRコードから読み取ったお薬を一括登録する。
   * 各薬品名で薬剤マスターを検索し、完全一致する薬剤が存在すれば登録する。
   */
  private async saveScannedItems() {
    this.showConfirm = false;
    let savedCount = 0;
    let skippedCount = 0;

    for (const item of this.scannedItems) {
      const matched = await new Promise<{
        yj_code: string;
        name: string;
      } | null>(resolve => {
        this.postJsonCheck(
          window.base_url + "/api/patient/medicine/items/get",
          { medicine_name: item.medicine_name },
          res => {
            const items: Array<{ yj_code: string; name: string; exact_matched?: boolean }> =
              res.data.medicine_items || [];
            const exact = items.find(m => m.exact_matched);
            resolve(exact ?? (items.length === 1 ? items[0] : null));
          }
        );
      });

      if (!matched) {
        skippedCount++;
        continue;
      }

      await new Promise<void>(resolve => {
        this.postJsonCheck(
          window.base_url + "/api/patient/medicine/save",
          {
            patient_medicine: {
              id: 0,
              patient_id: this.patientId,
              yj_code: matched.yj_code,
              start_date: item.start_date,
              end_date: "",
              remarks: item.remarks,
              updated_at: ""
            }
          },
          () => {
            savedCount++;
            resolve();
          }
        );
      });
    }

    const msg =
      skippedCount > 0
        ? `${savedCount}件を登録しました。（${skippedCount}件は薬剤マスターで見つからず、スキップしました）`
        : `${savedCount}件を登録しました。`;
    await this.$openAlert(msg);
    this.fetchPatientMedicines();
  }
}
